"use client";

import { useButton } from "./JOBHIYEN.js";
import { useDialogScopedContext } from "./CMXOY7UW.js";
import { createElement, createHook, forwardRef } from "./7FZLUSKW.js";
import { useEvent } from "./HNHAUIIY.js";
import { __objRest, __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/dialog/dialog-dismiss.tsx
import { useMemo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var TagName = "button";
var useDialogDismiss = createHook(function useDialogDismiss2(_a) {
  var _b = _a,
    store = _b.store,
    props = __objRest(_b, ["store"]);
  var context = useDialogScopedContext();
  store = store || context;
  var onClickProp = props.onClick;
  var onClick = useEvent(function (event) {
    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented) return;
    store == null ? void 0 : store.hide();
  });
  var children = useMemo(function () {
    return /* @__PURE__ */jsxs("svg", {
      "aria-label": "Dismiss popup",
      display: "block",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5,
      viewBox: "0 0 16 16",
      height: "1em",
      width: "1em",
      children: [/* @__PURE__ */jsx("line", {
        x1: "4",
        y1: "4",
        x2: "12",
        y2: "12"
      }), /* @__PURE__ */jsx("line", {
        x1: "4",
        y1: "12",
        x2: "12",
        y2: "4"
      })]
    });
  }, []);
  props = __spreadProps(__spreadValues({
    "data-dialog-dismiss": "",
    children: children
  }, props), {
    onClick: onClick
  });
  props = useButton(props);
  return props;
});
var DialogDismiss = forwardRef(function DialogDismiss2(props) {
  var htmlProps = useDialogDismiss(props);
  return createElement(TagName, htmlProps);
});
export { useDialogDismiss, DialogDismiss };